/*
Copyright (c) 2015, salesforce.com, inc. All rights reserved.
Copyright (c) 2017, Picsa Advisory Services (Pty) Ltd. All rights reserved.

Redistribution and use in source and binary forms, with or without modification, are permitted provided that the following conditions are met:
Redistributions of source code must retain the above copyright notice, this list of conditions and the following disclaimer.
Redistributions in binary form must reproduce the above copyright notice, this list of conditions and the following disclaimer in the documentation and/or other materials provided with the distribution.
Neither the name of salesforce.com, inc. nor the names of its contributors may be used to endorse or promote products derived from this software without specific prior written permission.

THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS" AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT OWNER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES LOSS OF USE, DATA, OR PROFITS OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
*/

import React from 'react'
import PropTypes from 'prop-types'
import { graphql } from 'react-apollo'
import gql from 'graphql-tag'

import {
  Spinner,
  Heading,
  SvgIcon,
  NavLink,
  SpanWithData
} from '../'

import {
  readablePhoneNumber
} from '../../utils'

class ClientSummary extends React.Component {
  static propTypes = {
    client: PropTypes.string.isRequired,
    linkToProfile: PropTypes.bool
  }

  render() {
    if (this.props.data.loading) {
      return <Spinner type="brand" />
    }

    if (this.props.data.error) {
      return <div>Failed to load client information</div>
    }

    let client = this.props.data.client

    return (
      <div className="slds-grid slds-wrap">
        <div className="slds-col slds-size_1-of-1">
          <Heading
            size="medium"
            className="slds-m-bottom_large">
            <strong>{`${client.identity.firstName} ${client.identity.lastName}`}</strong>
          </Heading>
        </div>
        <div className="slds-size_1-of-1 slds-m-bottom_large slds-text-color_success">
          <SvgIcon
            variant='utility'
            symbol='check'
            colour='success'
            size='x-small'
            className='slds-m-right_medium'
          />
          Active
        </div>
        <div className="slds-col slds-size_3-of-3 slds-medium-size_3-of-3 slds-large-size_1-of-2">
          <strong>Employer:</strong>
        </div>
        <div className="slds-col slds-size_3-of-3 slds-medium-size_3-of-3 slds-large-size_1-of-2">
          {client.division.employer.friendlyName}
        </div>
        <div className="slds-col slds-size_3-of-3 slds-medium-size_3-of-3 slds-large-size_1-of-2">
          <strong>ID number:</strong>
        </div>
        <div className="slds-col slds-size_3-of-3 slds-medium-size_3-of-3 slds-large-size_1-of-2">
          {client.identity.identityValue}
        </div>
        <div className="slds-col slds-size_3-of-3 slds-medium-size_3-of-3 slds-large-size_1-of-2">
          <strong>Language:</strong>
        </div>
        <div className="slds-col slds-size_3-of-3 slds-medium-size_3-of-3 slds-large-size_1-of-2">
          <SpanWithData forField="IdentityLanguage" searchKey={client.identity.language} />
        </div>
        <div className="slds-col slds-size_3-of-3 slds-medium-size_3-of-3 slds-large-size_1-of-2">
          <strong>Contact no.:</strong>
        </div>
        <div className="slds-col slds-size_3-of-3 slds-medium-size_3-of-3 slds-large-size_1-of-2">
          {client.identity.contactNumber.edges.length > 0
            ? readablePhoneNumber(client.identity.contactNumber.edges[0].node.addressValue)
            : "Unknown"
          }
        </div>
        {/* TODO: add fields below for v2 */}
        {/* <div className="slds-col slds-size_3-of-3 slds-medium-size_3-of-3 slds-large-size_1-of-2">
          <strong>ST balance:</strong>
        </div>
        <div className="slds-col slds-size_3-of-3 slds-medium-size_3-of-3 slds-large-size_1-of-2">
          R295 000
        </div>
        <div className="slds-col slds-size_3-of-3 slds-medium-size_3-of-3 slds-large-size_1-of-2">
          <strong>LT balance:</strong>
        </div>
        <div className="slds-col slds-size_3-of-3 slds-medium-size_3-of-3 slds-large-size_1-of-2">
          R1 500
        </div>
        <div className="slds-col slds-size_3-of-3 slds-medium-size_3-of-3 slds-large-size_1-of-2">
          <strong>Cash loan:</strong>
        </div>
        <div className="slds-col slds-size_3-of-3 slds-medium-size_3-of-3 slds-large-size_1-of-2">
          R2 000
        </div> */}
        {this.props.linkToProfile &&
          <NavLink
            to={`/os/identity/${client.identity.id}`}
            className="slds-col slds-size_1-of-1 slds-m-top_medium">
            See full profile
          </NavLink>
        }
      </div>
    )
  }
}

export const getClientEmploymentDetails = gql`
  query($id: ID!) {
    client(id: $id) {
      id
      division {
        id
        employer {
          id
          friendlyName
        }
      }
      identity {
        id
        firstName
        lastName
        identityValue
        language
        contactNumber: addresses(addressType: "msisdn", default: true) {
          edges {
            node {
              id
              addressValue
            }
          }
        }
      }
    }
  }

`

export const withData =
  graphql(getClientEmploymentDetails, {
    options: (ownProps) => ({
      variables: {
        id: ownProps.client
      }
    })
  })

export default withData(ClientSummary)



// WEBPACK FOOTER //
// ./src/components/client-summary/index.js